import React from 'react';

const GeenData = () => {
	return <label>Geen data</label>;
};

export default GeenData;
